import { RootStoreState } from './'

export const selectReady = (state: RootStoreState) => state.ready
